<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="call-log"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <div class="page-navigation-container d-flex flex-column flex-grow-1">
        <CallLogSearchForm
          v-if="callLogTab === '/call-log'"
        />

        <CallLogCustomerDetails
          v-else-if="isPermittedAll([
            'CustomersGetByID'
          ])"
          :customer="$store.state.activeCall.Customer"
        />
      </div>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Call Log Page Content -->
    <v-content>
      <v-toolbar class="flex-column pa-2" style="height: auto; min-height: 100px;">
        <div class="d-flex flex-wrap align-center mt-5 w-100">
          <v-app-bar-nav-icon
            class="page-drawer-toggle mr-0"
            @click="isDrawerOpen = !isDrawerOpen">
          </v-app-bar-nav-icon>

          <v-toolbar-title
            class="pl-0">
            <MainNavigationMenu />
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Page Filter -->
          <div
            class="page-filter"
            :class="isMobile ? 'w-100' : ''">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              filled
              hide-details
              v-model="callLogFilter"
              placeholder="Filter all calls">
            </v-text-field>
          </div>
          <!-- / Page Filter -->
        </div>
      </v-toolbar>

      <!-- Call Log Tabs -->
      <div
        class="call-tabs mx-5 mb-5"
        :class="isMobile ? '' : 'd-flex'">
        <div
          class="main-tabs mb-2">
          <v-tabs
            :show-arrows="false"
            optional
            v-model="callLogTab">
            <!-- All Calls -->
            <v-tab
              v-if="isPermittedAll([
                'CallsGetAll'
              ])"
              to="/call-log"
              exact>
              All Calls
            </v-tab>
            <!-- / All Calls -->

            <!-- New Call -->
            <v-tab
              v-if="isPermittedAll([
                'CallsCreate'
              ])"
              to="/call-log/new"
              exact>
              New Call
            </v-tab>
            <!-- / New Call -->
          </v-tabs>
        </div>

        <div
          :class="isMobile ? 'w-100' : 'open-call-tabs'"
          v-if="openCalls.length
            && isPermittedAll([
                'CallsCreate',
                'CallsGetByID'
              ])">
          <v-tabs
            center-active
            show-arrows
            optional
            v-model="callLogTab">
            <!-- View/Edit Closed Call -->
            <v-tab
              v-if="activeCall.CallEndUtc"
              :key="activeCall.CallID"
              :to="`/call-log/${activeCall.CallID}`"
              exact>
              <div>
                <div class="d-flex align-center">
                  <span
                    v-if="$store.getters.isActiveCallDirty"
                    class="mr-1">
                    *
                  </span>
                  <span
                    class="customer-status-dot small mr-1"
                    :class="activeCall.Customer.CustomerStatusColor.CustomerStatusColorName">
                  </span>
                  {{activeCall.Customer.CustomerName}}
                </div>
                <small>{{activeCall.CallStartUtc | dateAtTime}}</small>
              </div>
            </v-tab>
            <!-- / View/Edit Closed Call -->

            <!-- Open Calls -->
            <v-tab
              v-for="call in openCalls"
              :key="call.CallID"
              class="open-call"
              :to="`/call-log/${call.CallID}`"
              exact>
              <div>
                <div class="d-flex align-center">
                  <span
                    v-if="call.CallID === activeCall.CallID
                    && $store.getters.isActiveCallDirty"
                    class="mr-1">
                    *
                  </span>
                  <span
                    class="customer-status-dot small mr-1"
                    :class="call.Customer.CustomerStatusColor.CustomerStatusColorName">
                  </span>
                  {{call.Customer.CustomerName}}
                </div>
                <small>{{call.CallStartUtc | dateAtTime}}</small>
              </div>
            </v-tab>
            <!-- / Open Calls -->
          </v-tabs>
        </div>
      </div>
      <!-- / Call Log Tabs -->

      <!-- Call Log Table -->
      <CallLogTable
        v-if="callLogTab === '/call-log'"
        class="page-content mx-5 my-5"
        :call-log="callLog"
      />
      <!-- / Call Log Table -->

      <!-- Call Log Form -->
      <CallLogForm
        v-else
        class="page-content mx-5 mt-5"
      />
      <!-- / Call Log Form -->
    </v-content>
    <!-- / Call Log Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import UserMenu from '../components/UserMenu.vue';
import CallLogTable from '../components/CallLogTable.vue';
import CallLogForm from '../components/CallLogForm.vue';
import CallLogSearchForm from '../components/CallLogSearchForm.vue';
import CallLogCustomerDetails from '../components/CallLogCustomerDetails.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import PosmLogo from '../components/PosmLogo.vue';

export default {
  name: 'CallLogPage',
  components: {
    UserMenu,
    CallLogTable,
    CallLogForm,
    CallLogSearchForm,
    CallLogCustomerDetails,
    MainNavigationMenu,
    PosmLogo,
  },
  data() {
    return {
      callLogFilter: '',
      callLogTab: 0,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.checkDirtyBeforeRouteChange(next);
  },
  beforeRouteLeave(to, from, next) {
    this.checkDirtyBeforeRouteChange(next);
  },
  computed: {
    callLog() {
      return this.filterCalls(this.$store.state.callLog);
    },
    openCalls() {
      return this.filterCalls(this.$store.state.openCalls);
    },
    activeCall() {
      return this.$store.state.activeCall;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    filterCalls(calls) {
      const search = (this.callLogFilter || '').toLowerCase();

      return _.filter(
        calls,
        (call) => !search
          || call.Customer.CustomerName.toLowerCase().includes(search)
          || call.Customer.CustomerCity.toLowerCase().includes(search)
          || call.Customer.CustomerState.toLowerCase().includes(search),
      );
    },
    checkDirtyBeforeRouteChange(next) {
      const goToNext = () => {
        this.$store.commit('setActiveCall');
        next();
      };

      if (this.$store.getters.isActiveCallDirty) {
        this.showConfirm(
          'Are you sure you want to leave this call without saving?',
          'You have unsaved changes',
        ).then(goToNext, _.noop);
      } else {
        goToNext();
      }
    },
  },
};
</script>

<style lang="scss">
#call-log {
  .call-tabs {
    .v-tab {
      margin: 4px 2px;
    }

    .main-tabs {
      width: 162px;
      margin-right: 20px;

      .v-tabs-bar {
        padding: 0 2px;
      }

      .v-slide-group__prev,
      .v-slide-group__next {
        display: none;
      }
    }

    .open-call-tabs {
      width: calc(100% - 182px);
    }
  }
}
</style>
